import React from "react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Row,
  Col,
} from "reactstrap";
import RequestEngine from "../../core/RequestEngine";
import CoreEngine from "../../core/CoreEngine";
import ButtonLoader from "../../components/ButtonLoader/ButtonLoader";
import { AvForm } from "availity-reactstrap-validation";
import strings from "../../core/translate";
import SelectRow from "../../components/Select/SelectRow";
import FormRow from "../../components/Row/FormRow";

export default class MerchantBranchAddUpdate extends CoreEngine {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      id: "",
      user: "", // For storing selected user ID
      customerId: "", // For storing selected customer ID
      customerVehicleId: "", // For storing selected vehicle ID
      userList: [],
      customerUserList: [],
      customerVehicleList: [],
      loading: false,
      statusReason: "",
    };

    this.engine = new RequestEngine();
  }

  componentDidMount() {
    const { selectedMerchant, selectedBranch, selectedAppointment } =
      this.props.location.state || this.props.match.params;

    if (selectedMerchant && selectedBranch && selectedAppointment) {
      this.setState(
        {
          selectedMerchant,
          selectedBranch,
          selectedAppointment,
        },
        () => {
          // Fetch customers when the merchant is set
          if (selectedMerchant) {
            this.fetchCustomerUsers(selectedMerchant);
          }
        }
      );
    }
    const editData = this.props.location.data;

    if (editData) {
      this.setState(
        {
          ...editData,
          user: editData.customer?.user?.id || "", // Set user ID from editData
          customerId: editData.customer?.id || "",
          customerVehicleId: editData.customerVehicle?.id || "", // Set vehicle ID
          statusReason: editData.statusReason || "",
        },
        () => {
          // Fetch data for customer users and vehicles
          if (editData.customer?.user) {
            this.fetchCustomerUsers(editData.customer.user.id);
          }
          if (editData.customer?.id) {
            this.fetchCustomerVehicles(editData.customer.id);
          }
        }
      );
    }
  }

  // Fetch customer users based on the selected merchant ID
  fetchCustomerUsers = async (selectedMerchant) => {
    try {
      const responseCustomer = await this.engine.getItemlistDirect(
        `customers/${selectedMerchant}/users`
      );
      if (responseCustomer) {
        const customerData = responseCustomer.data.items;
        const customerUserList = customerData.map((c) => ({
          value: c.id,
          label: `${c.user.firstName} ${c.user.lastName} - ${c.merchant.name}`,
        }));
        this.setState({ customerUserList });
      }
    } catch (error) {
      console.error("Error fetching customer users:", error);
    }
  };

  fetchCustomerVehicles = async (customerUserId) => {
    try {
      const responseVehicle = await this.engine.getItemlistDirect(
        `customers/${customerUserId}/Vehicle`
      );
      if (responseVehicle) {
        const vehicleData = responseVehicle.data.items;
        const customerVehicleList = vehicleData.map((v) => ({
          value: v.id,
          label: `${v.make.name} ${v.model.name}`, // Label with make and model
        }));
        this.setState({ customerVehicleList });
      }
    } catch (error) {
      console.error("Error fetching customer vehicles:", error);
    }
  };

  handleCustomerUserSelect = (selectedOption) => {
    const customerUserId = selectedOption.value;
    this.setState(
      {
        customerId: customerUserId,
        customerVehicleId: "",
        customerVehicleList: [],
      },
      () => {
        this.fetchCustomerVehicles(customerUserId);
      }
    );
  };

  handleValidSubmit = async () => {
    this.setState({ loading: true });

    const {
      id,
      version, // Include version in payload
      statusReason,
      user,
      customerId,
      customerVehicleId,
      ...restData
    } = this.state;

    const data = {
      ...restData,
      customerId,
      customerVehicleId,
      statusReason,
      version, // Pass version in the request payload
    };

    const { selectedMerchant, selectedBranch, selectedAppointment } =
      this.props.location.state;
    const pathname = `merchants-branches/${selectedAppointment}/appointment-booking`;

    try {
      let response;
      if (id) {
        response = await this.engine.updateItem(pathname, id, data);
      } else {
        response = await this.engine.saveItem(pathname, data);
      }

      if (response && (response.status === 201 || response.status === 200)) {
        this.props.history.push({
          pathname: `/admin/merchants-branches/${selectedAppointment}/appointment-booking`,
          state: {
            selectedMerchant,
            selectedBranch,
            selectedAppointment,
          },
        });
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        alert("An error occurred: " + err.response.data.message);
      } else {
        alert("An unexpected error occurred: " + err.message);
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      loading,
      isLoading,

      customerId,
      customerVehicleId,

      customerUserList,
      customerVehicleList,
      statusReason,
      id,
    } = this.state;

    if (isLoading) {
      return this.renderProgress();
    }

    return (
      <div className="content english">
        <Row>
          <Col md="12">
            <AvForm
              onValidSubmit={this.handleValidSubmit}
              className="form-horizontal"
              id="TypeValidation"
            >
              <Card>
                <CardHeader>
                  <CardTitle tag="h4">{strings.information}</CardTitle>
                </CardHeader>
                <CardBody>
                  {!id && (
                    <SelectRow
                      label={strings.customer}
                      name="customerId"
                      defaultValue={customerUserList.find(
                        (c) => c.value === customerId
                      )}
                      data={customerUserList}
                      changeInput={this.handleCustomerUserSelect}
                    />
                  )}
                  <SelectRow
                    label={strings.customervehicle}
                    name="customerVehicleId"
                    defaultValue={customerVehicleId}
                    data={customerVehicleList}
                    changeInput={(e) =>
                      this.setState({ customerVehicleId: e.value })
                    }
                  />
                  <FormRow
                    label={strings.statusreason}
                    name="statusReason"
                    data={statusReason}
                    changeInput={this.changeInput.bind(this)}
                  />
                </CardBody>
                <CardFooter className="text-center">
                  <ButtonLoader color="primary" loading={loading}>
                    {strings.save}
                  </ButtonLoader>
                </CardFooter>
              </Card>
            </AvForm>
          </Col>
        </Row>
      </div>
    );
  }
}
